/**
 * 数组转对象
 * @param {*} keyName 数据中做为Key的名称，默认为'id',如果keyName不存在，则使用序号index
 * @param {*} valueName 数据中做为value的名称，默认为'tr'
 * @return { Object } 返回一个以对象
 */
Array.prototype.toObject = function(keyName = 'id', valueName = 'tr') {
  const tempObject = {};
  if (this && this.length) {
    this.map((item, index) => {
      tempObject[item[keyName] || index] = item[valueName] || item || null;
    });
  }
  return tempObject;
};
